import { useState } from 'react';
import { supabase } from '../../lib/supabase';

/**
 * Hook to handle anonymous player search functionality
 */
export function useAnonPlayerSearch() {
  const [anonLastName, setAnonLastName] = useState('');
  const [anonBirthdate, setAnonBirthdate] = useState('');
  const [foundPlayers, setFoundPlayers] = useState<any[]>([]);
  const [selectedPlayer, setSelectedPlayer] = useState<any>(null);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Anonymous search handler
  async function handleAnonSearch() {
    setError(null);
    setFoundPlayers([]);
    setSelectedPlayer(null);
    setIsSearching(true);

    if (!anonLastName || !anonBirthdate) {
      setError('Please enter both last name and birthdate.');
      setIsSearching(false);
      return null;
    }

    try {
      const { data, error: rpcError } = await supabase.rpc('get_players_for_checkin', {
        last_name_param: anonLastName,
        birthdate_param: anonBirthdate,
      });

      if (rpcError) {
        throw rpcError;
      }

      if (data && data.length > 0) {
        setFoundPlayers(data);
        if (data.length === 1) {
          // If only one player found, auto-select
          setSelectedPlayer(data[0]);
        }
        return data;
      } else {
        setError('No players found matching that last name and birthdate. If you have not registered your player, scan the appropriate QR code to register or ask booth staff for assistance.');
        return null;
      }
    } catch (err: any) {
      console.error('Error searching for players:', err);
      setError(`Failed to search for players: ${err.message}`);
      return null;
    } finally {
      setIsSearching(false);
    }
  }

  // Reset search state
  const resetSearch = () => {
    setAnonLastName('');
    setAnonBirthdate('');
    setFoundPlayers([]);
    setSelectedPlayer(null);
    setError(null);
  };

  return {
    anonLastName,
    setAnonLastName,
    anonBirthdate,
    setAnonBirthdate,
    foundPlayers,
    selectedPlayer,
    setSelectedPlayer,
    isSearching,
    error,
    handleAnonSearch,
    resetSearch
  };
}
